import { ColumnDef } from "@tanstack/react-table";
import { z, ZodObject, ZodRawShape } from "zod";
import LicensePlate from "license-plate";
import licencePlateSelectBg from "../../../../general/fields/modules/commons/licencePlateSelectField/assets/licencePlateSelectBg.svg";
import { useTranslation } from "react-i18next";

export const PackingSlipTableColumns: ColumnDef<
  z.infer<ZodObject<ZodRawShape>>
>[] = [
  {
    id: "date",
    accessorKey: "date",
    header: "date",
    cell: ({ row }) => {
      const dateString = row?.original.date;

      if (dateString === undefined || dateString === "" || dateString === null)
        return;

      const date = new Date(dateString);
      const formattedDate = new Intl.DateTimeFormat("en-GB")
        .format(date)
        .replace(/\//g, "-");

      return <span>{formattedDate}</span>;
    },
  },
  {
    id: "relation.name",
    accessorKey: "relation.name",
    header: "relation",
  },
  {
    id: "status",
    accessorKey: "status",
    header: "status",
    cell: ({ row }) => {
      const { t } = useTranslation("common");
      return t(row.original.status);
    },
  },
  {
    id: "route.truck.title",
    accessorKey: "route.truck.title",
    header: "truck",
    cell: ({ row }) => {
      const plate = new LicensePlate(row.original.route?.truck?.licence ?? "");

      return (
        <div className={"d-flex align-items-center gap-2"}>
          {row.original.route?.truck?.licence && (
            <div
              className={"tireset-table-licence-plate"}
              style={{
                background: `url(${licencePlateSelectBg}) no-repeat center center / cover`,
              }}
            >
              <div>
                {plate.valid()
                  ? plate.pretty()
                  : row.original.route?.truck?.licence}
              </div>
            </div>
          )}
          -<div>{row.original.route?.truck?.title}</div>
        </div>
      );
    },
  },
];
